import styled from "styled-components";
import {styled as muiStyled} from '@mui/system'

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(249, 250, 251, 0.98) 100%);
  /* Removed backdrop-filter to prevent blur issues when modals/drawers are open */
  border-bottom: 1px solid rgba(16, 185, 129, 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  z-index: 1000;
  transition: all 0.3s ease;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 12px 16px;
  }

  @media (max-width: 480px) {
    padding: 10px 12px;
  }
`

export const HeaderGreeting = styled.div`
  color: ${props => props?.main ? 'rgba(15, 23, 42, 0.95)' : 'rgba(100, 116, 139, 0.9)'};
  font-family: 'Inter', 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-style: normal;
  line-height: ${props => props?.main ? '1.3' : '1.5'};
  font-size: ${props => props?.main ? '22px' : '13px'};
  font-weight: ${props => props?.main ? '600' : '500'};
  letter-spacing: ${props => props?.main ? '-0.02em' : '0'};
  margin: ${props => props?.main ? '0' : '0 0 2px 0'};

  @media (max-width: 768px) {
    font-size: ${props => props?.main ? '18px' : '12px'};
  }
`

export const HeaderLinkText = styled.div`
  color: rgba(71, 85, 105, 0.85);
  font-family: 'Inter', 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-style: normal;
  line-height: 1.5;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  margin-right: 24px;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;

  &:hover {
    color: rgba(16, 185, 129, 0.95);
    background-color: rgba(16, 185, 129, 0.08);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 800px) {
    display: none;
  }
`

export const HeaderStatusOfUpdates = muiStyled("div")(({theme, customColor}) =>
    `
    background: ${customColor ? customColor : "linear-gradient(135deg, rgba(236, 253, 245, 0.95) 0%, rgba(209, 250, 229, 0.95) 100%)"};
    padding: 12px 24px;
    display: flex;
    justify-content: center;
    font-weight: 500;
    color: rgba(15, 23, 42, 0.9);
    font-size: 14px;
    gap: 8px;
    font-family: 'Inter', 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    align-items: center;
    flex-wrap: wrap;
    border-bottom: 1px solid rgba(16, 185, 129, 0.1);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    @media (min-width: 768px) {
        gap: 15px;
        padding: 14px 24px;
    }
    @media (max-width: 768px) {
        padding: 10px 16px;
        font-size: 13px;
    }
`)
